export default {
  register: 'register',
  home: 'home',
  start: 'start',
  pricing: 'pricing',
  extensionLogin: 'extension-login',
  connectToNotion: 'connect-to-notion',
  legalNotice: 'legal-notice',
  privacyPolicy: 'privacy-policy',
  termsOfUse: 'terms-of-use',
  plans: 'plans',
  sidepanel: 'sidepanel',
  unsupportedBrowser: 'unsupported-browser',
};
